import { Route, Routes } from 'react-router-dom'
import LoginRoutes from './LoginRoutes'
import ScrollToTop from '../components/scrolltoTop/ScrollToTop'
import BackToTopButton from '../pages/backtotop/backbutton'
import FLoatingbutton from '../pages/floatingdonatebutton/floatingbutton'

const AllRoutes = () => {
  return (
    <>
    <ScrollToTop />
    <FLoatingbutton></FLoatingbutton>
    <BackToTopButton></BackToTopButton>
      <Routes>
        <Route path="/*" element={<LoginRoutes />} />
      </Routes>
    </>
  )
}

export default AllRoutes